<template>
  <div id="wrap">
    <!-- logo -->
    <div class="logo"></div>
    <!-- title -->
    <div class="title">天机汇</div>
    <div
      class="text"
    >天机汇，是专业的二手机B2B交易平台，主要为B端客户提供二手机在线买卖服务。每天都有海量的货源供应，现已推出VIP专属服务和各类优惠补贴政策，为二手行业货源流通运转提供巨大助力。</div>
    <!-- 展示栏 -->
    <div class="displayBar1">
      <div class="img"></div>
      <div class="content">
        <div class="title">二手机市场行情</div>
        <div
          class="text"
        >天机汇通过平台交易数据积累，为二手数码行情提供实时行情价格走势，为行业提供实时二手机供需价格参照与供需服务，为二手行业商户提供行情数据、交易撮合等数据能力。</div>
      </div>
    </div>
    <!-- 第二个展示栏 -->
    <div class="displayBar2">
      <div class="content">
        <div class="title">全网二手机聚合交易</div>
        <div
          class="text"
        >天机汇聚合全网二手供需委托单，为全网二手B端商户提供交易撮合，加速行业供需运转，同时提供二手机竞拍、采购和回收业务，打造成熟二手数码B端平台分为，为B端商户能提供高品质交易撮合服务。</div>
      </div>
      <div class="img"></div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#wrap {
  //   background-color: skyblue;
  .logo {
    width: 70px;
    height: 70px;
    background-image: url("../../assets/imgs/product/j.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    margin-bottom: 20px;
  }
  .title {
    color: #000000;
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 40px;
  }
  .text {
    line-height: 28px;
    font-size: 16px;
    margin-bottom: 60px;
  }
  //   展示区
  .displayBar1 {
    width: 1034px;
    height: 321px;

    display: flex;
    margin-bottom: 70px;
    box-shadow: 0px 0px 20px #eee;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("https://p5.ssl.qhimg.com/t010e56d4796e117f27.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 77px 64px 110px 51px;
      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
  //   第二个展示区
  .displayBar2 {
    width: 1034px;
    height: 321px;
    box-shadow: 0px 0px 20px #eee;
    display: flex;
    margin-bottom: 60px;
    .img {
      width: 327px;
      height: 321px;
      background-image: url("https://p4.ssl.qhimg.com/t01f1705cfde7dbfa10.png");
      background-repeat: no-repeat;
      background-size: cover;
    }
    .content {
      width: 707px;
      height: 321px;
      padding: 78px 53px 110px 64px;

      .title {
        font-size: 20px;
        color: #03050e;
        font-weight: 600;
        margin-bottom: 38px;
        text-align: right;
      }
      .text {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
}
</style>
